import {
  PublicProfileValidationError,
  assertValidPublicHandle,
  normalizePublicHandle,
} from './publicProfileModel.js';

export const COMMUNITY_AGE_STATEMENT_VERSION =
  'selective-go-live-16-plus-v1';

export const COMMUNITY_IDENTITY_ACQUISITION_PATH = Object.freeze({
  EMAIL_SIGNUP: 'email_signup',
  SOCIAL_SIGNUP: 'social_signup',
  FIRST_ACTION: 'first_action',
});

export const COMMUNITY_IDENTITY_ACQUISITION_PATHS = Object.freeze(
  Object.values(COMMUNITY_IDENTITY_ACQUISITION_PATH),
);

export class CommunityIdentityValidationError extends Error {
  constructor(message, code = 'invalid_community_identity') {
    super(message);
    this.name = 'CommunityIdentityValidationError';
    this.code = code;
  }
}

export const normalizeCommunityIdentityStatus = (payload = {}) => {
  const handle = normalizePublicHandle(payload?.handle);
  const ageAttested = Boolean(
    payload?.age_attested ?? payload?.ageAttested,
  );
  const statementVersion =
    payload?.statement_version ?? payload?.statementVersion ?? null;
  const acquisitionPath =
    payload?.acquisition_path ?? payload?.acquisitionPath ?? null;
  const attestedAt = payload?.attested_at ?? payload?.attestedAt ?? null;

  return {
    handle,
    ageAttested,
    statementVersion,
    acquisitionPath,
    attestedAt,
    ready: Boolean(handle && ageAttested),
  };
};

export const buildCommunityIdentityCompletion = (input = {}) => {
  if (input.ageConfirmed !== true) {
    throw new CommunityIdentityValidationError(
      'Devi confermare di avere almeno 16 anni.',
      'age_confirmation_required',
    );
  }

  let handle;
  try {
    handle = assertValidPublicHandle(
      normalizePublicHandle(
        input.handle ?? input.publicHandle ?? input.public_handle,
      ),
    );
  } catch (error) {
    if (error instanceof PublicProfileValidationError) {
      throw new CommunityIdentityValidationError(
        error.message,
        error.code,
      );
    }
    throw error;
  }

  if (!handle) {
    throw new CommunityIdentityValidationError(
      'Serve un handle community.',
      'public_handle_required',
    );
  }

  const statementVersion = String(input.statementVersion || '').trim();
  if (statementVersion !== COMMUNITY_AGE_STATEMENT_VERSION) {
    throw new CommunityIdentityValidationError(
      'Versione della dichiarazione 16+ non valida.',
      'unsupported_age_statement_version',
    );
  }

  const acquisitionPath = String(input.acquisitionPath || '').trim();
  if (!COMMUNITY_IDENTITY_ACQUISITION_PATHS.includes(acquisitionPath)) {
    throw new CommunityIdentityValidationError(
      'Percorso di acquisizione non valido.',
      'invalid_community_identity_acquisition_path',
    );
  }

  return {
    handle,
    statementVersion,
    acquisitionPath,
  };
};
